/**
 * @hidden
 */
export var EMPTY_SELECTIONRANGE = { start: null, end: null };



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-dateinputs/dist/es/calendar/models/SelectionRange.js
// module id = 117
// module chunks = 93